import { render, staticRenderFns } from "./NorticTextInput.vue?vue&type=template&id=f826dac4&scoped=true&"
import script from "./NorticTextInput.vue?vue&type=script&lang=js&"
export * from "./NorticTextInput.vue?vue&type=script&lang=js&"
import style0 from "./NorticTextInput.vue?vue&type=style&index=0&id=f826dac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f826dac4",
  null
  
)

export default component.exports